import { BehaviorSubject } from 'rxjs';
import { ErrorVariant } from '../../../model/error-variant.model';
import { TranslocoService } from '@ngneat/transloco';
import { BreadcrumbsService } from '../../../../core/services/breadcrumbs.service';
import { SeoService } from '../../../../core/services/seo.service';
import { SsrService } from '../../../../core/services/ssr.service';

export class Page {

  readonly fullPageError$: BehaviorSubject<ErrorVariant | null>;

  constructor(protected translocoService: TranslocoService,
              protected breadcrumbService: BreadcrumbsService,
              protected seoService: SeoService,
              protected ssrService: SsrService) {
    this.fullPageError$ = new BehaviorSubject<ErrorVariant | null>(null);
  }

  showFullPageError(errorVariant: ErrorVariant): void {
    this.fullPageError$.next(errorVariant);

    if (errorVariant === 404) {
      this.ssrService.setHttpStatus(404);
      this.translocoService.selectTranslate('ERROR.NOT_FOUND.BREADCRUMB').subscribe(val => {
        this.breadcrumbService.setBreadcrumbs([{path: '.', label: val}]);
        this.seoService.setTitle(val);
      });
    } else {
      this.translocoService.selectTranslate('ERROR.DEFAULT.BREADCRUMB').subscribe(val => {
        this.breadcrumbService.setBreadcrumbs([{path: '.', label: val}]);
        this.seoService.setTitle(val);
      });
    }

  }

  hideFullPageError(): void {
    this.fullPageError$.next(null);
  }

}
